














import Vue from 'vue';
import Component from 'vue-class-component';
import JdiContent from '../../components/JdiContent.vue';
import JdiPreview from '@/components/JdiPreview.vue';
import JdsEcho from '@/design-system/components/Echo/JdsEcho.vue';
@Component({
    components: { JdsEcho, JdiPreview, JdiContent },
})
export default class Echo extends Vue {
}
